import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	enableAri as enableAriApi,
	disableAri as disableAriApi,
	outboundAriConfig
} from 'util/Api';

const enable = createAsyncThunk(
	'ari/enable',
	async (
		{ threadId, candidateId, sequenceId, text, initialMessageOverride },
		{ rejectWithValue }
	) => {
		try {
			return await enableAriApi(threadId, candidateId, sequenceId, text, initialMessageOverride);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const disable = createAsyncThunk('ari/disable', async ({ threadId }, { rejectWithValue }) => {
	try {
		return await disableAriApi(threadId);
	} catch (err) {
		return rejectWithValue(err);
	}
});

const getSequences = createAsyncThunk(
	'ari/getSequences',
	async ({ threadId }, { rejectWithValue }) => {
		try {
			return await outboundAriConfig(threadId);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

export const ariActions = {
	enable,
	disable,
	getSequences
};
